module.exports = __webpack_public_path__ + "img/D8D8E5_9D9DAF_B4B4C4_B4B4CC-256px.fc5ae708.png";